module.exports = __webpack_public_path__ + "static/7-9c311a618c54534f69341fd059448fb2.jpg";